import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextArea from 'app/scripts/components/common/inputs/textarea-input';

class BroadcastMessage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      message: props.value,
      status: 'error'
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var oldMessage = this.props.value;
    var newMessage = nextProps.value;

    if (oldMessage !== newMessage) {
      var status = newMessage.length ? 'success' : 'error';
      this.setState({ message: newMessage, status });
    }
  }
  onMessageChange(message) {
    var empty = !message || !message.trim().length;
    var status = null;
    if (empty) {
      status = 'error';
    } else {
      status = 'success';
    }
    this.setState({ message, status });
  }
  getValue() {
    return this.state.message;
  }
  isValid() {
    return this.state.status === 'success' && this.state.message.length;
  }
  render() {
    var { message, status } = this.state;
    var { validate, disabled } = this.props;

    var props = {
      onChange: this.onMessageChange.bind(this),
      description: 'Your message',
      value: message || '',
      maxLength: 140,
      placeholder: 'Add a custom message to give context to your Broadcast',
      disabled: disabled,
      showCharCounter: true
    };

    if (validate) {
      props.hasError = status === 'error';
    }

    return <TextArea {...props} />;
  }
}

BroadcastMessage.propTypes = {
  validate: PropTypes.bool,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  spotId: PropTypes.string
};

BroadcastMessage.defaultProps = {
  value: ''
};

BroadcastMessage.displayName = 'BroadcastMessage';

export default BroadcastMessage;
